<div class="{{ 'dialog ' + data.type }} ">
  <img src="{{ data.icon }}" />
  <div class="error-text">{{ data.message }}</div>
  <div class="actions" [ngClass]="{ single: data.buttons.length === 1 }">
    <div
      *ngFor="let button of data.buttons"
      class="button"
      (click)="close(button.id)"
    >
      {{ button.text }}
    </div>
  </div>
</div>
